import type { SearchResult } from './types';

const STORAGE_KEY = 'scarlet-search-recent';
const MAX_RECENT = 8;

type RecentItem = {
  id: string;
  title: string;
  href?: string;
  kind: SearchResult['kind'];
  ts: number;
};

function readRecent(): RecentItem[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as RecentItem[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeRecent(items: RecentItem[]) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_RECENT)));
}

export function recordRecentSelection(result: SearchResult) {
  if (result.kind === 'assistant' || result.kind === 'action') return;
  const items = readRecent().filter((i) => i.id !== result.id);
  items.unshift({
    id: result.id,
    title: result.title,
    href: result.href,
    kind: result.kind,
    ts: Date.now(),
  });
  writeRecent(items);
}

export function recordRecentNavigation(entry: { id: string; title: string; href: string }) {
  recordRecentSelection({
    id: `nav-${entry.id}`,
    kind: 'feature',
    group: 'RECENT',
    title: entry.title,
    href: entry.href,
    score: 0,
  });
}

export function getRecentSearchResults(): SearchResult[] {
  return readRecent().map((item, index) => ({
    id: `recent-${item.id}`,
    kind: item.kind,
    group: 'RECENT',
    title: item.title,
    href: item.href,
    score: 800 - index,
    subtitle: 'Recently opened',
  }));
}

export function getRecentIdSet(): Set<string> {
  return new Set(readRecent().map((i) => i.id));
}

export function clearRecentSearchItems() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(STORAGE_KEY);
}
